import { observer } from "mobx-react-lite";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import EditableDetailView from "views/common/editableDetailView";
import CountryForm from "./countryForm";
import CountryDetailViewModel from "viewModels/timeCharges/distributorEnums/countries/countryDetailViewModel";

const CountryDetailView: ViewComponent<CountryDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<CountryForm vm={vm} />} />;
});

registerView(CountryDetailView, CountryDetailViewModel);
